import { registerTask, type TaskModule } from '@/domain/core/taskModule';
import type { DotProbeConfig } from '@/domain/core/protocol.schema';
import { wordAssetId, type WordStimulusSet } from '@/domain/stimuli/types';
import { generateDotProbeTrials, type DotProbeMeta } from './generator';

export const dotProbeModule: TaskModule<DotProbeConfig, WordStimulusSet, DotProbeMeta> = {
  kind: 'CBM_A',
  responseMode: 'vertical',
  collectAssets(stimuli) {
    const words = new Set<string>();
    for (const p of stimuli.threatNeutralPairs) { words.add(p.threat); words.add(p.neutral); }
    for (const n of stimuli.neutralNeutralPairs) { words.add(n.a); words.add(n.b); }
    return [...words].map((text) => ({ id: wordAssetId(text), text }));
  },
  generate(config, stimuli, seed, geometry) {
    // 기본 진입점은 평가 arm. arm 별 생성은 generateDotProbeTrials 를 직접 부른다.
    return generateDotProbeTrials(config, stimuli, seed, geometry, 'assessment');
  },
};

registerTask(dotProbeModule);
export { generateDotProbeTrials, type DotProbeMeta, type Arm } from './generator';
